import { render, staticRenderFns } from "./NftList.vue?vue&type=template&id=e2e314d4&scoped=true"
import script from "./NftList.vue?vue&type=script&lang=js"
export * from "./NftList.vue?vue&type=script&lang=js"
import style0 from "./NftList.vue?vue&type=style&index=0&id=e2e314d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e314d4",
  null
  
)

export default component.exports